import './teacher.css';
import Modal from '../Modal';
import Edit from '../Edit';
import Confirm from '../Confirm';
import del from '../../../img/delete.png';
import AdditionalInformation from './AdditionalInformation';
import { componentOpenDelete, componentOpenEdit } from '../utils';
import {useState} from "react";
import GetLastTest from "../student/Get-last-test";

const StudentsListItem = (props) => { 
	const {onDelete, dop} = props;
	const [subInfo,setSubInfo]=useState(props.subInfo)
	const [name,setName]=useState(props.name)
	const editUser = (newName) => {
		setName(newName);
	}
	function deleteStudent( ) {
    onDelete(props.idSt)
  }

	function componentOpenAdditionalFields() {
		return (<div className='profile_edit-open'><img className="teach_turn_img" src={del}/></div>)
	}

	return (
		<tr>
			<td>
				<p>{props.count}</p>
			</td>
			<td>{props.variants}</td>
			<td>
				<p>{props.grade}</p>
			</td>
				<td>
				<p>{name}</p>
				</td>
				{dop.map(key => subInfo[key] ? <td key={key}> {subInfo[key]} </td>: <td key={key}></td>)}
				<td className='teacher_student-settings'>
						{/* <Modal additional={{idSt:props.idSt, dop:subInfo,setSubInfo:setSubInfo}} component={AdditionalInformation} componentOpen={componentOpenAdditionalFields}/>
						<Modal  additional={{name: name, type:'user', id:props.idSt,editUser:editUser}} componentOpen={componentOpenEdit} component={Edit}/> */}
						{/* <Modal additional={{funcYes: deleteStudent, text: "Вы уверенны что хотите удалить?"}} componentOpen={componentOpenDelete} component={Confirm}/> */}
					<GetLastTest userId={props.idSt}/>
				</td>
		</tr>
	)
}

export default StudentsListItem;